import { render, staticRenderFns } from "./detailsContent.vue?vue&type=template&id=6539cb24&"
import script from "./detailsContent.vue?vue&type=script&lang=js&"
export * from "./detailsContent.vue?vue&type=script&lang=js&"
import style0 from "./detailsContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports